export default __webpack_public_path__ + "static/media/avtar13.226287ec.jpg";